// extracted by mini-css-extract-plugin
export var active = "_d1-c";
export var compactArrow = "_d1-5";
export var container = "_d1-0";
export var dot = "_d1-b";
export var dotContainer = "_d1-a";
export var hoverArrowButton = "_d1-7";
export var hoverArrowContainer = "_d1-6";
export var leftHoverArrowContainer = "_d1-8 _d1-6";
export var rightHoverArrowContainer = "_d1-9 _d1-6";
export var slide = "_d1-4";
export var sliderContainer = "_d1-1";
export var sliderContainerVisibleOverflow = "_d1-2";
export var sliderOverflow = "_d1-3";
export var vignetteBoth = "_d1-f";
export var vignetteLeft = "_d1-e";
export var vignetteRight = "_d1-d";